export const useCategoryAncestorsIsExam = (
  pAncestors: CategorySchema[] | Ref<CategorySchema[]>
): boolean => {
  const ancestors = toValue(pAncestors);
  const categoryExam =
    ancestors.find((cat) => {
      return cat.contentType === ContentTypes.Exam;
    }) ?? null;

  return categoryExam !== null;
};
